import gql from 'graphql-tag';

import {QueryResultType, useSkippableBenchlingQuery} from 'graphql-client/BenchlingQuery';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';
import {isInaccessible} from 'graphql-client/InaccessibleInfo';

import {TagSchemaGraphQL} from '../../graphql-fragments/schemas/tag-schemas/__generated/TagSchemaGraphQL';
import {GetFullTagSchemaQuery, GetFullTagSchemaQueryVariables} from './__generated/GetFullTagSchemaQuery';

export const GET_FULL_TAG_SCHEMA_QUERY = gql`
  query GetFullTagSchemaQuery($id: StrictString!) @skipAudit @engComponent(name: REGISTRY) {
    tagSchema(id: $id) {
      ...TagSchemaGraphQL
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('TagSchema').fragment}
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

export interface UseTagSchemaQueryResult {
  tagSchema: TagSchemaGraphQL | null;
  isLoading: boolean;
  refetch: () => Promise<unknown>;
}

export default function useTagSchemaQuery(tagSchemaId?: string | null): UseTagSchemaQueryResult {
  const skip = tagSchemaId == null;
  const result = useSkippableBenchlingQuery<GetFullTagSchemaQuery, GetFullTagSchemaQueryVariables>(
    GET_FULL_TAG_SCHEMA_QUERY,
    {variables: {id: tagSchemaId!}, skip}
  );

  const refetch = result.refetch ?? (() => Promise.resolve());

  if (skip) {
    return {tagSchema: null, isLoading: false, refetch};
  } else if (result.type !== QueryResultType.SUCCESS) {
    return {tagSchema: null, isLoading: result.type === QueryResultType.PENDING, refetch};
  } else {
    const tagSchema = result.data.tagSchema;
    return {
      tagSchema: isInaccessible(tagSchema) ? null : tagSchema,
      isLoading: false,
      refetch,
    };
  }
}
